import React from 'react';
import outinvoice_logo from '../../Assets/svg/logo.svg';
// import login_img from '../../Assets/images/auth/login_images.png';
import login_img from '../../Assets/images/auth/login.svg';
import LoginEmailPassword from '../../Components/login/LoginEmailPassword.component';
import '../../Assets/css/login.css';
import { NavLink } from 'react-router-dom';
import {Helmet} from "react-helmet";

const LoginPage = () => {
  return (
    <div className='auth auth-login'>
      <Helmet>
                <meta charSet="utf-8" />
                <title>Outinvoice | Login</title>
      </Helmet>
      <div className='row no-gutters'>
        <div className='col-md auth__left'>
          <div className='auth__content'>
            <div className='auth__logo'>
              <img
                className='logo-img'
                src={outinvoice_logo}
                srcSet={outinvoice_logo}
                alt='logo'
              />
            </div>
            <div className='auth__body'>
              <h1 className='auth__title text-2 text-md'>Sign In</h1>
              <div className='auth__description'>
                <p className='text-5 text-semibold'>
                  Invoicing for entrepreneurs
                </p>
                <p className='text-8 text-regular'>
                  Create invoices in seconds, manage subscriptions with ease.
                </p>
              </div>
              <LoginEmailPassword />
              <div className='auth__more'>
                <p className='text-6 text-md text-default'>
                  Don't have an account? <NavLink to='/signup'>Sign Up</NavLink>
                </p>
              </div>
            </div>
          </div>
        </div>
        <div className='col-md text-center my-auto'>
          <div className='auth__banner login'>
            <div className='auth__banner-content'>
              <div className='img-wrapper'>
                <img
                  className='auth__login-im ms-auto'
                  src={login_img}
                  alt='banner'
                  height='500'
                  width='550'
                />
              </div>
              <div className='text-center p-5'>
                <h3 className='text-dark fw-medium'>
                  Manage your invoices with confidence
                </h3>
                <p className=''>
                  {/* <p style={{padding: '10px 100px'}}> */}
                  Outinvoice saves your time, gets you paid, and makes managing
                  customer information stress-free. Start exploring all the free
                  invoicing{' '}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoginPage;
